import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=bf94e91e&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94e91e",
  null
  
)

export default component.exports